export default "__VITE_ASSET__BJLhT51R__"